import styled from 'styled-components';

export const Resource = styled.span`
  display: inline-block;
  margin: 0 8px 0 0;
`;
